import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-subscriber-list',
  templateUrl: './subscriber-list.component.html',
  styleUrl: './subscriber-list.component.scss'
})
export class SubscriberListComponent implements OnInit {

  repId!: number;
  month!: number;
  year!: number;
  subscribers: any[] = [];
  loading = true;
  error = '';
  rep_name: any
  monthYear: any

  constructor(
    private route: ActivatedRoute,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.repId = params['rep'];   // encrypted rep
      this.month = params['m'];     // encrypted month
      this.year = params['y'];     // encrypted year
      if (this.repId) {
        this.monthYear = this.getMarathiMonthYear();
        this.loadSubscribers();
      } else {
        this.error = 'Invalid Representative';
        this.loading = false;
      }
    });
  }

  getMarathiMonthYear(): string {
    const monthsMarathi = [
      'जानेवारी',
      'फेब्रुवारी',
      'मार्च',
      'एप्रिल',
      'मे',
      'जून',
      'जुलै',
      'ऑगस्ट',
      'सप्टेंबर',
      'ऑक्टोबर',
      'नोव्हेंबर',
      'डिसेंबर'
    ];

    const today = new Date();

    // Move to next month
    const nextMonthDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    const monthName = monthsMarathi[nextMonthDate.getMonth()];
    const year = nextMonthDate.getFullYear();

    return `${monthName} - ${year}`;
  }

  loadSubscribers(): void {
    this.loading = true;

    this.service.getSubscribersByRep(this.repId, this.month, this.year).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.subscribers = res.data;
          this.rep_name = res.data[0]?.rep_name || '';
          this.error = '';
        } else {
          this.subscribers = [];
          this.error = 'No subscribers found';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load subscribers';
        this.loading = false;
      }
    });

  }

}